import { useAuth } from '@clerk/clerk-react';
import { ReactNode } from 'react';
import { motion } from 'framer-motion';
import LandingPage from '../../../pages/LandingPage';

interface ProtectedRouteProps {
  children: ReactNode;
  fallback?: ReactNode;
}

export function ProtectedRoute({ children, fallback }: ProtectedRouteProps) {
  const { isLoaded, isSignedIn } = useAuth();

  if (!isLoaded) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-white">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.3 }}
          className="flex flex-col items-center space-y-4"
        >
          <div className="relative">
            <div className="w-12 h-12 border-4 border-gray-200 rounded-full"></div>
            <div className="w-12 h-12 border-4 border-black border-t-transparent rounded-full animate-spin absolute top-0 left-0"></div>
          </div>
          <div className="text-gray-600 font-light">Loading...</div>
        </motion.div>
      </div>
    );
  }

  if (!isSignedIn) {
    return fallback || <LandingPage />;
  }

  return <>{children}</>;
}

export default ProtectedRoute;